// extracted by mini-css-extract-plugin
module.exports = {"FPGAnimator":"FPGAnimator__FPGAnimator--1Q31W","wrap":"FPGAnimator__wrap--2HeIC"};